export default __webpack_public_path__ + "static/media/match-found.cb83f7ae.png";